(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["catalog-ranked-search"] && !Shopify.designMode) return;
  try {
    (async () => {
  const root = document.querySelector('[data-ranked-search]');
  const first = document.querySelector('template[data-catalog-batch]');
  if (!root || !first) return;
  const normalize = value => value.toLocaleLowerCase('de-DE').normalize('NFKD').replace(/[\u0300-\u036f]/g,'').replace(/ß/g,'ss').trim();
  const query = normalize(root.dataset.query);
  const tokens = query.split(/[^\p{L}\p{N}]+/u).filter(Boolean);
  if (!tokens.length) return;
  const entries = new Map();
  const append = template => template.content.querySelectorAll('[data-catalog-item]').forEach(e=>entries.set(e.dataset.id,e.cloneNode(true)));
  append(first);
  let next = first.dataset.next;
  const visited = new Set();
  try {
    while (next) {
      const url = new URL(next,location.href);
      url.searchParams.set('section_id',root.dataset.section);
      if (url.origin !== location.origin || visited.has(url.href)) throw new Error('Invalid catalog page');
      visited.add(url.href);
      const response = await fetch(url,{credentials:'same-origin'});
      if (!response.ok) throw new Error('Catalog unavailable');
      const doc = new DOMParser().parseFromString(await response.text(),'text/html');
      const batch = doc.querySelector('template[data-catalog-batch]');
      if (!batch) throw new Error('Catalog unavailable');
      append(batch); next = batch.dataset.next;
    }
    const includesAll = value => tokens.every(t=>value.includes(t));
    const matches = [];
    entries.forEach(e=>{
      const title=normalize(e.dataset.title),model=normalize(e.dataset.model),ids=e.dataset.identifiers.split('|').map(normalize).filter(Boolean),description=normalize(e.dataset.description);
      let rank=0;
      if (model===query || ids.includes(query)) rank=1000;
      else if (title===query) rank=950;
      else if (includesAll(model)) rank=900;
      else if (includesAll(title)) rank=800;
      else if (ids.some(includesAll)) rank=700;
      else if (includesAll(title+' '+model+' '+ids.join(' '))) rank=600;
      else if (includesAll(description)) rank=100;
      if(rank) matches.push({e,rank,title});
    });
    matches.sort((a,b)=>b.rank-a.rank||a.title.localeCompare(b.title,'de'));
    const status=document.createElement('p');status.className='global-search-count';status.setAttribute('role','status');status.textContent=root.dataset.countLabel.replace('__COUNT__',matches.length);
    const grid=document.createElement('div');grid.className='global-search-grid';
    matches.forEach(({e})=>grid.append(e));
    root.append(status,grid);
    document.title = status.textContent + ' · ' + document.title.split(' · ').slice(-1)[0];
    if(!matches.length){const empty=document.createElement('p');empty.textContent=root.dataset.emptyLabel;root.append(empty);}
    document.querySelector('[data-native-results]').hidden=true;
    root.hidden=false;
    const form=root.parentElement.querySelector('.global-product-search');
    if(form) form.after(root);
  } catch(error) {
    root.hidden=true;
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nav-product-search"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.nav-search').forEach(details=>{
const input=details.querySelector('input[type="search"]'),summary=details.querySelector('summary');
details.addEventListener('toggle',()=>{if(details.open){document.querySelectorAll('.nav-search').forEach(other=>{if(other!==details)other.open=false});input.focus()}});
details.addEventListener('keydown',event=>{if(event.key==='Escape'&&details.open){event.stopPropagation();details.open=false;summary.focus()}});
details.querySelector('form').addEventListener('reset',()=>requestAnimationFrame(()=>input.focus()));
document.addEventListener('click',event=>{if(details.open&&!details.contains(event.target))details.open=false});
details.addEventListener('focusout',()=>requestAnimationFrame(()=>{if(!details.contains(document.activeElement))details.open=false}));
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    const header = document.querySelector('.site-header.unified-header');
    if (!header || header.dataset.stickyReady) return;
    header.dataset.stickyReady = 'true';
    const sync = () => {
      document.documentElement.style.setProperty('--lauxx-header-height', header.offsetHeight + 'px');
      header.classList.toggle('is-scrolled', window.scrollY > 24);
    };
    sync();
    window.addEventListener('scroll', sync, {passive:true});
    new ResizeObserver(sync).observe(header);
    const jump = () => {
      if (location.hash !== '#kompetenzen') return;
      const target = document.getElementById('kompetenzen');
      if (target) target.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    };
    document.addEventListener('click', event => {
      const link = event.target.closest('a[href]');
      if (!link) return;
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin || url.pathname !== location.pathname || url.hash !== '#kompetenzen') return;
      event.preventDefault();
      header.classList.add('anchor-jump');
      link.blur();
      history.pushState(null, '', url.hash);
      jump();
    });
    header.addEventListener('pointerleave', () => header.classList.remove('anchor-jump'));
    header.addEventListener('focusin', () => header.classList.remove('anchor-jump'));
    window.addEventListener('hashchange', jump);
    window.addEventListener('load', jump, {once:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();
  } catch(e) { console.error(e); }
})();

})();
